import { FilterEqOperation } from '../types/types';
import { CollectionFilterModel } from '../models/CollectionFilterModel';
import { CustomCollectionFilterModel } from '../models/CustomCollectionFilterModel';
import _ from 'lodash';
var CollectionFiltersService = /** @class */ (function () {
    function CollectionFiltersService(mainCollectionId, filterConfigsService) {
        this.mainCollectionId = mainCollectionId;
        this.filterConfigsService = filterConfigsService;
        this.collectionFilterModels = [];
    }
    CollectionFiltersService.prototype.createCollectionFilterModel = function (filterType, filterOptions) {
        var enabledFilterOptions = this.getEnabledCollectionFilterOptions(filterOptions);
        var title = this.filterConfigsService.getFilterConfigTitle(filterType);
        var collectionFilterModel = new CollectionFilterModel(filterType, title, enabledFilterOptions, this.mainCollectionId);
        this.collectionFilterModels.push(collectionFilterModel);
        return collectionFilterModel;
    };
    CollectionFiltersService.prototype.createCustomCollectionFilterModels = function (filterType, filterOptions) {
        var _this = this;
        var _a;
        var customCollectionFilterConfigs = this.filterConfigsService.getCustomCollectionFilterConfigs();
        var customCollectionFilterModels = customCollectionFilterConfigs.map(function (filterConfig) {
            var enabledFilterOptions = _this.filterConfigsService.getEnabledFilterOptionsFromFilterConfig(filterOptions, filterConfig);
            return new CustomCollectionFilterModel(filterType, filterConfig.filterTitle, enabledFilterOptions);
        });
        (_a = this.collectionFilterModels).push.apply(_a, customCollectionFilterModels);
        return customCollectionFilterModels;
    };
    CollectionFiltersService.prototype.toDTO = function () {
        var collectionIds = [];
        var collectionFilterDTO;
        this.collectionFilterModels.forEach(function (filterModel) {
            collectionIds = collectionIds.concat(filterModel.activeOptions);
        });
        collectionIds = _.uniq(collectionIds);
        if (this.shouldAddDefaultFilter(collectionIds)) {
            collectionFilterDTO = this.getDefaultFilterDTO();
        }
        else {
            if (this.shouldAddMainCollectionId(collectionIds)) {
                collectionIds.unshift(this.mainCollectionId);
            }
            collectionFilterDTO = {
                field: this.filterConfigsService.isUsingLegacyAPI ? 'categoryId' : 'categories',
                op: FilterEqOperation.IN_ALL,
                values: collectionIds,
            };
        }
        return collectionFilterDTO;
    };
    CollectionFiltersService.prototype.getDefaultFilterDTO = function () {
        return {
            field: this.filterConfigsService.isUsingLegacyAPI ? 'categoryId' : 'categories',
            op: FilterEqOperation.EQUALS,
            values: [this.mainCollectionId],
        };
    };
    CollectionFiltersService.prototype.getEnabledCollectionFilterOptions = function (filterOptions) {
        var result = _.cloneDeep(filterOptions);
        var collectionFilterConfigs = this.filterConfigsService.getCollectionFilterConfigs();
        if (collectionFilterConfigs.length !== 0) {
            result = this.filterConfigsService.getEnabledFilterOptionsFromFilterConfig(filterOptions, collectionFilterConfigs[0]);
        }
        return result;
    };
    CollectionFiltersService.prototype.shouldAddDefaultFilter = function (collectionIds) {
        return collectionIds.length === 0 || this.isOnlyMainCollectionIdSelected(collectionIds);
    };
    CollectionFiltersService.prototype.isOnlyMainCollectionIdSelected = function (collectionIds) {
        return collectionIds.length === 1 && collectionIds[0] === this.mainCollectionId;
    };
    CollectionFiltersService.prototype.shouldAddMainCollectionId = function (collectionIds) {
        return collectionIds.indexOf(this.mainCollectionId) === -1;
    };
    return CollectionFiltersService;
}());
export { CollectionFiltersService };
//# sourceMappingURL=CollectionFiltersService.js.map